<template>
  <div>
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.show"
      width="600px"
      center
    >
      <el-form :inline="true" label-width="100px" v-model="mFormData">
        <el-form-item :label="$t('Operator')" v-show="zong">
          <el-select
            v-model="mFormData.SellerId"
            :placeholder="$t('Operator')"
            style="width: 200px"
            @change="OnChangeSellerId"
            :disabled="dialogData.opt == 1"
          >
            <el-option
              v-for="item in userSellerList"
              :key="item.SellerId"
              :label="item.SellerName"
              :value="item.SellerId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('channel')">
          <el-select
            v-model="mFormData.ChannelId"
            :placeholder="$t('channel')"
            style="width: 150px"
            :disabled="dialogData.opt == 1"
          >
            <el-option
              v-for="item in dialogchannel"
              :key="item.ChannelId"
              :label="item.Name"
              :value="item.ChannelId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ConfigurationName')+':'">
          <el-input
            v-model="mFormData.ConfigName"
            style="width: 400px"
            :disabled="dialogData.opt == 1"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('ConfigurationValue')+':'">
          <el-input
            type="textarea"
            v-model="mFormData.ConfigValue"
            style="width: 400px"
            :rows="6"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Explanation')+':'">
          <el-input
            type="textarea"
            v-model="mFormData.Remark"
            style="width: 400px"
            :rows="8"
          ></el-input>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')">
          <el-input
            v-model="mFormData.GoogleCode"
           :placeholder="$t('GoogleVerificationCode')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">{{ $t('Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
export default {
  extends: base,
  components: {},
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      mFormData: {
        SellerId: "",
        ChannelId: 0,
        ConfigName: "",
        ConfigValue: "",
        Remark: "",
        GoogleCode: "",
      },
    };
  },
  computed: {
    dialogchannel() {
      let channelList = JSON.parse(localStorage.getItem("channel")) || [];
      let arr = [];
      if (this.mFormData.SellerId) {
        arr = channelList.filter(
          (item) => item.SellerId == this.mFormData.SellerId
        );
      } else {
        arr = channelList;
      }
      let tList = app.clone(arr);
      tList.unshift({
        ChannelId: 0,
        Name: this.$t('all'),
      });
      return tList;
    },
  },
  created() {
    if (this.dialogData.row.SellerId) {
      for (const key in this.dialogData.row) {
        this.mFormData[key] = this.dialogData.row[key];
      }
    }
    if (!this.zong) this.mFormData.SellerId = this.filters.SellerId;
    this.getChannel(this.mFormData.SellerId || this.filters.SellerId);
  },
  methods: {
    OnChangeSellerId(pVal) {
      this.changeSellerId(pVal);
      this.mFormData.ChannelId = 0;
    },
    handleConfirm() {
      if (!this.mFormData.SellerId) return this.$message.error(this.$t('SelectOperatorAgain'));
      if (!this.mFormData.GoogleCode)
        return this.$message.error(this.$t('EnterGoogleVerificationCode'));
      for (const key in this.mFormData) {
        this.dialogData.row[key] = this.mFormData[key];
      }
      if (this.dialogData.opt == 1) {
        app.post("/admin/config/modify", this.dialogData.row, (result) => {
          this.dialogData.show = false;
          this.$message.success(this.$t('ModificationSuccessful'));
          this.$emit("success");
        });
      }
      if (this.dialogData.opt == 2) {
        app.post("/admin/config/add", this.dialogData.row, (result) => {
          this.dialogData.show = false;
          this.$message.success("添加成功");
          this.$emit("success");
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .el-switch__label.is-active {
  color: red;
}

::v-deep .el-switch__label {
  color: #409eff;
}
</style>
